"use client";

import { FC } from "react";
import PETProductsGrid from "./default";
import { VariantProps } from "./default";

const HaiAnhPETProductsGrid: FC<VariantProps> = (props) => (
  <PETProductsGrid {...props} theme="haianh" />
);

HaiAnhPETProductsGrid.displayName = "HaiAnhPETProductsGrid";

export default HaiAnhPETProductsGrid;
